import { utl_parseData, html } from "../base/_utils";
import Papa from "papaparse";

document.addEventListener("DOMContentLoaded", () => {
    const donorTable = document.querySelector("#donor-table");

    async function getAndDisplayData() {
        const donorData = "https://docs.google.com/spreadsheets/d/e/2PACX-1vSDS-Pr7RsNPtkJbFxULeqGOI6ENBR1cAPVIZ5ACmBszmOV_3bP3a6sSqdkfmtor0KgfoN2ykzSoBS5/pub?gid=0&single=true&output=csv";

        try {
            // Fetch and parse the data
            const results = await utl_parseData(donorData, Papa);
            let data = results.data;

            // Display the data
            for (let i = 0; i < data.length; i++) {
                donorTable.innerHTML += html`
                    <tr>
                        <td>${data[i].recipientColumn}</td>
                        <td>${data[i].sportColumn}</td>
                        <td>${data[i].hometownColumn}</td>
                        <td>${data[i].endowmentColumn}</td>
                    </tr>
                `;
            }
        } catch (error) {
            // Handle errors
            console.error("Error parsing data:", error);
        }
    }

    getAndDisplayData();
});
